import { useEffect, useState } from 'react';
import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import AddIcon from '@material-ui/icons/Add';
import commonStyles from '../../../styles';
import CommonDialog from '../../modal';
import CustomerCardItem from './customerCardItem';
import RegisterCustomerCard from './registerCustomerCard';
import { dateFormatter } from '../../../../commonFunction';

const useStyles = makeStyles((theme) => ({
  content: {
    background: '#fff',
    overflowY: 'auto',
    padding: 24,
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
  },
  table: {
    maxHeight: '300px',
  },
  tableHead: {
    borderBottom: '2px solid #C8C8C8',
    '& th:nth-child(1)': {
      textAlign: 'center',
      width: '12%',
    },
    '& th:nth-child(2)': {
      textAlign: 'center',
      width: '24%',
    },
    '& th:nth-child(3)': {
      paddingLeft: 14,
      width: '64%',
    },
  },
  tableLbl: {
    backgroundColor: '#fff',
    color: '#8C8C8C',
    padding: 0,
    lineHeight: 1.6,
  },
  tableRow: {
    backgroundColor: '#fff',
    '&:nth-child(even)': {
      background: '#F3F3F3',
    },
  },
  startIcon: {
    color: theme.palette.primaryColor,
    width: 18,
    height: 18,
    marginRight: 0,
  },
  addButtonTxt: {
    marginLeft: '-5px',
    color: theme.palette.primaryColor,
  },
}));

export default function CustomerCardComponent(props) {
  const {
    cards,
    open,
    onClose,
    getCustomerCards,
    postCustomerCards,
    getCustomerCardImage,
    customerId,
  } = props;

  const classes = useStyles();
  const baseClasses = commonStyles();

  const [registerOpen, setRegisterOpen] = useState(false);

  const registrationDate = dateFormatter(new Date());

  useEffect(() => {
    if (open) getCustomerCards();
  }, [open]);

  const body = (
    <>
      <Button
        startIcon={<AddIcon className={classes.startIcon} />}
        onClick={() => { setRegisterOpen(true); }}
      >
        <Typography className={`${baseClasses.strong} ${classes.addButtonTxt}`}>
          追加
        </Typography>
      </Button>
      <Grid className={`${classes.content}`}>
        <TableContainer className={classes.table}>
          <Table stickyHeader aria-label="simple table">
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell
                  className={`${baseClasses.title6} ${classes.tableLbl}`}
                >
                  日付
                </TableCell>
                <TableCell
                  className={`${baseClasses.title6} ${classes.tableLbl}`}
                >
                  登録者
                </TableCell>
                <TableCell
                  className={`${baseClasses.title6} ${classes.tableLbl}`}
                />
              </TableRow>
            </TableHead>
            <TableBody>
              {cards.map((card) => {
                return (
                  <TableRow className={classes.tableRow}>
                    <CustomerCardItem card={card} getCustomerCardImage={getCustomerCardImage} />
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <RegisterCustomerCard
        open={registerOpen}
        setOpen={setRegisterOpen}
        registrationDate={registrationDate}
        getCustomerCards={getCustomerCards}
        postCustomerCards={postCustomerCards}
        customerId={customerId}
      />
    </>
  );

  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      title="顧客カード管理ウィンドウ"
      width={640}
    >
      {body}
    </CommonDialog>
  );
}
